import { __rest, __assign, __awaiter, __generator } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React, { useRef } from 'react';
import { Select } from '@sravni/react-design-system';
import { mergeRefs } from '@sravni/react-utils';
import { wait } from '../../../helpers/index.js';

var SelectInput = React.forwardRef(function (props, ref) {
    var onBlur = props.onBlur, onChange = props.onChange, label = props.label, errorMessage = props.errorMessage, invalid = props.invalid, other = __rest(props, ["onBlur", "onChange", "label", "errorMessage", "invalid"]);
    var inputRef = useRef(null);
    var isPropagateEvent = useRef(false);
    var onChangeHandler = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var current;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (onChange) {
                        onChange(value);
                    }
                    return [4 /*yield*/, wait(0)];
                case 1:
                    _a.sent();
                    if (onBlur) {
                        onBlur(value);
                    }
                    current = inputRef.current;
                    if (current) {
                        isPropagateEvent.current = true;
                        current.blur();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onBlurHandler = function (event) {
        if (!isPropagateEvent.current) {
            event.stopPropagation();
        }
        else {
            isPropagateEvent.current = false;
        }
    };
    return (jsx(Select, __assign({ ref: mergeRefs(ref, inputRef), label: label || undefined }, other, { onChange: onChangeHandler, onBlur: onBlurHandler, invalid: Boolean(errorMessage || invalid) })));
});
SelectInput.displayName = 'SelectInput';

export { SelectInput };
//# sourceMappingURL=select.input.js.map
